import React from 'react';
import { Routes, Route } from "react-router-dom";
import IssuerReportsModule from "./issuer-reports-module/issuer-reports-module";

const Issuer_Reports = () => {
  return (
    <Routes>
      <Route index element={<IssuerReportsModule />} />
    </Routes>
  )
}

export default Issuer_Reports;



